module.exports = "/images/milano-3.jpg";